import React, { ReactElement } from "react";
import { LinealGauge } from "../../../layout/gauges/LinealGauge";
import { formatPercentage } from "../../../../helper/unitsFormatting";
import { formatSpeed } from "../../../../helper/formatSpeeds";
import { nullOrValue } from "../../../../helper/utils";
import t from "../../../../helper/t";

export const UploadPending = (): ReactElement => {
  return (
    <div>
      <div className="measurement-speed-display">
        <p>{t("Upload-Geschwindigkeit")}</p>
        <span className="speed-display-number">--</span>
      </div>
    </div>
  )
};

export const UploadRunning = (): ReactElement => {
  return (
    <div className="server-pc">
      <div className="server-text">{t("Unser Server")}</div>
      <div className="pc-text">{t("Dein Computer")}</div>
      <div className="mobile-text">{t("Dein Smartphone")}</div>
      <div className="speedtest-server-pc-gif">
        <img src="/img/measurement/messung_upload.gif" alt="messung-upload" />
      </div>
      <div className="speedtest-server-mobile-gif">
        <img
          src="/img/measurement/messung_upload_mobile.gif"
          alt="messung-upload-mobile"
        />
      </div>
      <div className="messen-aktuell">
        {t("Upload_Line_1")}
        <br />
        {t("Upload_Line_2")}
      </div>
    </div>
  )
};

interface UploadFinishedProps {
  actualSpeed_bps: number,
  bookedSpeed_bps: number | null | undefined,
}

export const UploadFinished: React.FC<UploadFinishedProps> = ({
  actualSpeed_bps,
  bookedSpeed_bps,
}) => {
  const percentageFormatted = formatPercentage(actualSpeed_bps, bookedSpeed_bps);
  const { unit, values: [actualSpeedStr, bookedSpeedStr] } = formatSpeed([actualSpeed_bps, nullOrValue(bookedSpeed_bps)]);

  return (
    <div data-cy="card-upload-finished" className="measurement-speed-display">
      <p>{t("Upload-Geschwindigkeit")}</p>
      <span className="info-text">
        {t("Gemessen von Deinem Computer zu unserem Server")}
      </span>
      {bookedSpeedStr === null ? (
        <>
          <div className="measurement-speed-display-number">
            <p id="uploadMeasurementValue">
              <span className="active-original no-customer-label">{actualSpeedStr}</span> &nbsp; {unit}
            </p>
          </div>
        </>
      ) : (
        <>
          <div className="lineal-slider">
            <LinealGauge actualSpeed_bps={actualSpeed_bps} bookedSpeed_bps={bookedSpeed_bps} />
            <div id="uploadMeasurementValue" className="gauge-lineal-label">
              {actualSpeedStr}
            </div>
            <div className="gauge-lineal-units">{unit}</div>
            <div className="gauge-lineal-content">
              <div className="gauge-lineal-min">0</div>
              <div className="gauge-lineal-max">
                {bookedSpeedStr}
              </div>
              <div className="gauge-lineal-percent">
                <strong>
                  <span>{percentageFormatted}</span>
                  {"% "}
                </strong>
                {t("Deines Tarifs von")}{" "}
                <strong>
                  <span className="gauge-lineal-tarif">
                    {bookedSpeedStr}{" "}{unit}
                  </span>
                </strong>
              </div>
            </div>
          </div>
          <span className="measurement-compare-info">
            <span className="active-green">
              {percentageFormatted}
              %
            </span>
          </span>
          <br />
          <span className="measurement-compare-info-text">
            {t("Deines gebuchten Tarifs")}
          </span>
          <span className="measurement-compare-info-text compare-info-value">
            {bookedSpeedStr}{" "}{unit}
          </span>
        </>
      )}
    </div>
  );
};
